import React, { Component } from 'react';
import FormResults from './components/FormResults';
import 'sweetalert/dist/sweetalert.css';
import RaisedButton from 'material-ui/RaisedButton';
import { translate } from 'react-i18next';
import WaitingModal from '../generics/WaitingModal';
import Notifications, {notify} from 'react-notify-toast';
import swal from 'sweetalert';
import 'sweetalert/dist/sweetalert.css';
import ModalAuth from '../patient/unitReserve/modalAuth';
import ModalReason from './components/modalReason';

var Config = require('../../config');

const style = {
  margin: 7,
};

class ResultsNew extends Component{
	constructor(props) {
	    super(props);
	    this.saveItem = this.saveItem.bind(this);
	    this.cancel = this.cancel.bind(this);
	    this.openReasonModal = this.openReasonModal.bind(this);
	    this.getData = this.getData.bind(this);
	    this.openAuth = this.openAuth.bind(this);
	    this.saveReason = this.saveReason.bind(this);
	    this.onSave = this.onSave.bind(this);
	    this.handleChange = this.handleChange.bind(this);

	    this.state = {
	    	sample:{},
	    	results:[],
	    	validation:"",
	    	validated:false,
	    	donor_age:"",
	    	donor_name:"",
	    	donor_sex:"",
	    	person_id:"",
	    	hideActions:false,
	    	disable_save:false,
	    };
	}

	componentWillMount() {
		setTimeout(function(){
          this.getData();
        }.bind(this), 200);

  	}

  	handleChange(e){
  		this.setState({[e.target.name]:e.target.value});
  	}
  	getData(id, modal, validate){
  		if(modal !== false){
  			this.props.waiting.handleShow('Cargando...');
  		}
  		
  		var sample = id !== undefined ? id : this.props.match.params.sample_id;
  		fetch(Config.default.apiGateway.URL+'samples/'+sample, {
			method : 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Typet'	: 'application/json'
			})

		})
		.then(res => {			
			if(res.ok){
				return res.json();
			}
		})
		.catch(error => console.error('Error:', error))
		.then(response => {
			if(response !== undefined){
				this.setState({
					sample: response.sample,
					results: response.results,
					validation: response.validation,
					validated:response.validated,
					donor_age: response.donor_age,
					donor_name: response.donor_name,
					donor_sex: response.sex,
					person_id: response.person_id,
				});


				if(response.email_info !== null && response.email_info !== undefined){
					this.form.setState({
						email_info: response.email_info
					});
				}

				if(response.print_info !== null && response.print_info !== undefined){
					this.form.setState({
						print_info: response.print_info
					});
				}

				if(response.group_rh !== ""){
					this.form.setState({
						validation:response.validation, 
						donation_notes_id: response.donation_notes_id,
						person_group_rh: response.group_rh,
						enableAntibody: false
					});
				}else{
					this.form.setState({
						validation:response.validation, 
						donation_notes_id: response.donation_notes_id,
						enableAntibody:false
					});
				}

				if(response.total_sections > 0){
					this.form.setState({
						total_sections: response.total_sections,
						enableAntibody:false
					});
				}
				
				this.form.getLabSections(validate);

				setTimeout(()=>{
					if(response.sample.donation_id === null){
						this.form.getfenotipoAntibody(response.sample.id, 'fenotipo_muestra');
						this.form.getfenotipoAntibody(response.sample.id, 'antibody_muestra');
					}

					if(response.sample.donor_id !== null){
						
						this.form.getfenotipoAntibody(response.person_id, 'antibody_donante');
						this.form.getfenotipoAntibody(response.person_id, 'fenotipo_donante');
					}
				}, 500)
					
			}
				
		});
  	}

	cancel(e){
		if(this.props.location.pathname.indexOf('/search/') === -1){
			/*if(this.props.match.params.donation_id !== '0'){
			//	this.props.history.push("/results_donation");
			}else{
			//	this.props.history.push("/sample_results");
			}*/
			this.props.history.goBack();
		}else{
			var id = this.form.state.data_donor.donor_id;
			this.props.history.push("/search_donor/"+id);
		}
	}

	openAuth(id, vacio, screen){
		this.modal_auth.handleShow(id, vacio, screen);
	}

	openReasonModal(msg, obj){
		if(msg === 'sin_procesos'){
			//this.onSave();
			this.saveReason(obj);
			this.form.onRemove(this.form.state.aux_api, this.form.state.aux_sections);

			this.modal_reason.handleClose();
		}else{
			this.modal_reason.handleShow(this.form.state.data_donor.donation.donation_number, msg);	
		}
	}

	saveReason(obj){
		var item = {
			donation_number: obj.donation_number,
			reason:obj.reason, 
			detail:obj.detail,
			sections: this.form.state.aux_sections, 
		};
		
		this.modal_reason.saveAuth(item);
	}

	//Funcion Submit Form
	saveItem(e, validate){
		e.preventDefault();
		/*var force = false;
		if(this.props.location.state !== undefined){
			if(this.props.location.state.force === true){
				force = true;
			}
		}

		if(this.state.validation !== 'ACCEPTED' && this.state.validation !== 'REJECT'){
			
			if(!force){
				this.openAuth(this.form.state.data_donor.donation.id, '', 'laboratory');
			}else{
				this.onSave();
			}
		}*/

		this.onSave(e, validate);
	}

	onSave(e, validate){
		if (this.state.disable_save) {
	        return;
	    }
		this.setState({disable_save:true});
		var items = this.form.getResults();
		this.props.waiting.handleShow('Guardando...');
		
      	fetch(Config.default.apiGateway.URL+'sample_results?sample_id='+this.props.match.params.sample_id, {
		  method: 'PUT', // or 'PUT'
		  body: JSON.stringify(items), // data can be `string` or {object}!
		  headers: new Headers({
		  	'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
		  	'Accept': 'application/json',
		  	'Content-Type': 'application/json;charset=UTF-8'
		  })
		})
		.then(res => {
	          //this.waiting_modal.handleClose();
	            if(res.ok){
	              return res.json();
	            }else{
	              res.text().then(function(error) {
	                swal('¡Error!', error, 'error');
	              });
	          }
	    })
		.then(response => {
	    	if(response !== undefined){
	    		this.setState({disable_save:false});
	    		notify.show('Registro Guardado','success');
				this.getData(undefined, false, validate);
				
	    	}
		});
	}

	//Contenido de la pantalla para el alta de un nuevo registro
	render(){
		const { t } = this.props;
		var donation_id = this.props.match.params.donation_id;
		return(
			<div className="col-xs-12" style={{paddingTop:"10px"}}>
				<h2 style={{textAlign:"center"}}>
					{donation_id !== '0' ? "Resultado de la Donación" : "Resultado de la Muestra"}</h2>
		        <form noValidate>
		        	<FormResults {...this.props} state={this.state} onRef={ref => (this.form = ref)} 
		        		waiting_modal = {this.waiting_modal}
		        		getData={this.getData} 
		        		validation={this.state.validation}
						handleChange={this.handleChange}
						saveItem={this.saveItem}
		        		openAuth={this.openAuth}/>
		        	<WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)}/>
		        	<ModalAuth {...this.props} 
		        		saving={this.openReasonModal} 
		        		saveReason={this.saveReason} 
		        		onRef={ref => (this.modal_auth = ref)} />
		        	<ModalReason {...this.props} onRef={ref => (this.modal_reason = ref)} 
		        		auth={this.openAuth} 
		        		onSave={this.form !== undefined ? this.form.onRemove : (e)=>e.preventDefault()}  />
		        	<Notifications />
		        </form>
		        <div className="col-xs-12" style={{textAlign:'center'}}>
		        	{!this.state.hideActions?
		        		<RaisedButton className="action-btn" label="GRABAR" primary={true} onClick={this.saveItem} style={style}
		        			disabled={this.state.disable_save}/>
			        :null}
		        	
	        		<RaisedButton className="action-btn" label="REGRESAR" primary={true} onClick={this.cancel} style={style}/>
		        </div>
		    </div>
		);
	}
}

export default translate('translations')(ResultsNew)